"use client";

import NextImage, { type ImageProps as NextImageProps } from "next/image";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";

import {
	SolutionBaseCards,
	type SolutionBasedCardsProps
} from "@/composite/SolutionBasedCard";
import type { ComplexCardReference } from "@/types/references";
import { resolveImageProps } from "@/app/utilities/images";

import type { SolutionBasedCardBlockProps } from ".";

export interface SolutionBasedCardBlockClientProps extends SolutionBasedCardBlockProps {
	cardsContent?: ComplexCardReference[];
}

/**
 * Solution Based Card block component
 */
export function SolutionBasedCardBlock({
	featured_headline,
	cardsContent
}: SolutionBasedCardBlockClientProps): JSX.Element {
	return (
		<SolutionBaseCards<NextImageProps, NextLinkProps>
			featuredText={{
				eyebrow: featured_headline.eyebrow,
				headline: featured_headline.headline,
				theme: featured_headline.theme as SolutionBasedCardsProps["featuredText"]["theme"]
			}}
			slides={
				cardsContent?.length
					? cardsContent?.map((card) => ({
							title: {
								tag: card?.headline.headline_tag,
								children: card?.headline.headline
							},
							description: card.description,
							image: {
								component: NextImage,
								...resolveImageProps(
									"1:1",
									card.multimedia_assets.asset_blocks[0]
								)
							},
							cta: {
								component: NextLink,
								href: card.cta_group[0]?.cta.link.href ?? "",
								children: card.cta_group[0]?.cta.link.title
							}
						}))
					: []
			}
		/>
	);
}
